import type { QueryClient } from '@tanstack/react-query';

type BriefCard = { setId: number };
type BriefMessage = { angleSetCard?: BriefCard };

/** Return the actual card object: a repeated same-ID event still has a new
 * identity and must refresh an already open document after an edit. */
export function latestAngleSetCard(messages: readonly BriefMessage[] | undefined, setId: number): BriefCard | undefined {
  for (let index = (messages?.length ?? 0) - 1; index >= 0; index--) {
    const card = messages![index].angleSetCard;
    if (card?.setId === setId) return card;
  }
}

export function refreshAngleSetCard(client: QueryClient, card: BriefCard | undefined, setId: number) {
  if (card?.setId === setId) return client.invalidateQueries({ queryKey: ['angle-set', setId], exact: true });
}
